function addXAxisLabels(
  nodesGroup,
  nodesData,
  schoolWithLineNodes,
  getDateFromIndex,
  x,
  height,
  axisPadding
) {
  const axisLabels = nodesGroup.selectAll('.x-label').data(nodesData);
  const baselineText = window.matchMedia('(min-width: 600px)').matches
    ? 'used as baseline'
    : 'baseline';
  const XAxisLables = schoolWithLineNodes.projections_years;
  axisLabels
    .enter()
    .append('text')
    .html((d, i) => {
      if (i === 1) {
        return `
          <tspan dy="0">${XAxisLables[i]}</tspan>
          <tspan x=${x(getDateFromIndex(i))} dy="1.3em">(${baselineText})</tspan>
        `;
      }
      return XAxisLables[i];
    })
    .style('font-size', d => {
      if (window.matchMedia('(min-width: 600px)').matches) {
        return '0.75rem';
      }
      return '1.5rem';
    })
    .style('fill', '#404040')
    .attr('class', 'x-label')
    .attr('text-anchor', 'middle')
    .attr('x', (d, i) => {
      return x(getDateFromIndex(i));
    })
    .attr('y', d => height + axisPadding);
}

export default addXAxisLabels;



// WEBPACK FOOTER //
// ./src/components/singleClusterProjectionsLineGraph/addXAxisLabels.js